export enum messageStatuses {
  NEW = 'NEW',
  UNREAD = 'UNREAD',
  READ = 'READ',
  REPLIED = 'REPLIED',
  REPLIED_STAFF = 'REPLIED_STAFF',
  CLOSED = 'CLOSED',
  DELETED = 'DELETED'
}
